import classes from './difficulty-meter.module.css';

export const DifficultyMeter = ({ value, label = 'Сложность' }: { value: number; label?: string }) => (
  <span className={classes.root}>
    <span>Сложность</span>
    <span
      className={classes.track}
      role="meter"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={5}
      aria-valuenow={value}
    >
      {Array.from({ length: 5 }, (_, index) => (
        <span key={index} data-filled={index < value || undefined} />
      ))}
    </span>
  </span>
);
